import axios from 'axios';
import { endpoints } from '../../../common/endpoints';
import buildRequest from '../../buildRequest';
import { stGetToken } from '../../storage';

export const getApiBitacora = async params => {
  const url = `${process.env.REACT_APP_api}${endpoints.bitacora}`;
  const method = 'get';
  const dataResponse = {
    success: false,
    statusCode: 0,
    message: '',
    data: [],
  };

  const request = {
    oportunidadId: params,
  };

  const { data: token } = stGetToken();

  try {
    const response = await axios[method](url, buildRequest(token, request));

    const { data } = response;

    dataResponse.success = true;
    dataResponse.data = data.data;
  } catch (error) {
    dataResponse.message = error.response.data.message;
    dataResponse.statusCode = error.response.status;
    dataResponse.success = false;
  }
  return dataResponse;
};
export const postApiBitacora = async params => {
  const url = `${process.env.REACT_APP_api}${endpoints.bitacora}`;
  const method = 'post';
  const dataResponse = {
    success: false,
    statusCode: 0,
    message: '',
    data: [],
  };

  const { data: token } = stGetToken();

  const request = {
    descripcion: params.comentario,
    oportunidadId: params.oportunidadId,
    etapaId: params.etapaId,
  };

  try {
    const response = await axios[method](url, request, buildRequest(token));

    const { data } = response;

    dataResponse.success = true;
    dataResponse.data = data.data;
  } catch (error) {
    dataResponse.message = error.response.data.message;
    dataResponse.statusCode = error.response.status;
    dataResponse.success = false;
  }
  return dataResponse;
};
